import React, { useRef } from 'react';
import classNames from 'classnames';
import { Button } from '../../organisms/button/Button';
import ZoomIn from '../../atoms/static-icons/zoom-in';

export const ImmagineContenutoHtml = ({
  isMobile,
  imageElement,
  handleClick,
}) => {
  const imageRef = useRef();
  return (
    <>
      <Button
        type={'icon-big'}
        icon={ZoomIn}
        className={classNames('zoom-image-button', {
          'zoom-image-button--mobile': isMobile,
        })}
        onClick={(e) => {
          e.stopPropagation();
          handleClick({
            src: imageElement?.attribs?.src,
            alt: imageElement?.attribs?.alt,
          });
        }}
      />
      <button
        className='zoom-image-img-wrapper'
        onClick={(e) => {
          e.stopPropagation();
          handleClick({
            src: imageElement?.attribs?.src,
            alt: imageElement?.attribs?.alt,
          });
        }}
      >
        <img
          ref={imageRef}
          src={`${imageElement?.attribs?.src}`}
          alt={`${imageElement?.attribs?.alt || ''}`}
        ></img>
      </button>
    </>
  );
};
